/** @jsxImportSource @emotion/react */
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { Grid, GridItem } from '@nike/nike-design-system-components';
import { withRouter } from 'react-router-dom';

import { TranslatedCopy } from '../intl/TranslatedCopy';

import Button from '../components/button/Button';
import Table from '../components/table/Table';
import { fetchNotifications } from './actions';
import { notifications } from './reducer';
import columns from './columns';

import Page from '../admin/common/Page';

const Notifications = ({ fetchNotifications, notifications, history }) => {
  const createNewNotification = () => history.push('/notifications/new');
  const handleUserClick = id => history.push(`/notifications/edit/${id}`);

  useEffect(() => {
    fetchNotifications();
  }, []);

  return (
    <Page
      title='Outage Notifications'
      HeaderContent={
        <Grid className='pb4-sm'>
          <GridItem>
            <Button extraClassName='ncss-btn-primary-dark d-sm-h d-md-b' onClick={createNewNotification}>
              <TranslatedCopy id='notifications.add' />
            </Button>
          </GridItem>
        </Grid>
      }
    >
      <Table
        className='pt9-sm pb9-sm'
        bodyClassName='bg-secondary-grey pt3-sm pb3-sm u-full-height'
        data={notifications}
        columns={columns}
        handleClick={handleUserClick}
        clickTarget='id'
      />
    </Page>
  );
};

Notifications.propTypes = {
  fetchNotifications: PropTypes.func.isRequired,
  notifications: PropTypes.array.isRequired,
  history: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  notifications: notifications(state)
});

export default connect(mapStateToProps, { fetchNotifications })(withRouter(Notifications));
